import { render } from "./RegLoginForm.vue?vue&type=template&id=2a9d822f&scoped=true"
import script from "./RegLoginForm.vue?vue&type=script&lang=js"
export * from "./RegLoginForm.vue?vue&type=script&lang=js"

import "./RegLoginForm.vue?vue&type=style&index=0&id=2a9d822f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a9d822f"

export default script